import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import localStorageAccessor from "@utility/local-storage-accessor";
import { PermissionChecker, Permission } from "@utility/permission-checker";
const RootRedirect = () => {
    var _a, _b;
    // Use localStorage directly instead of Redux to avoid state sync issues during redirects
    const isAuthenticated = localStorageAccessor.isAuthenticated();
    const location = useLocation();
    if (!isAuthenticated) {
        return React.createElement(Navigate, { to: "/insight/login", replace: true });
    }
    // Define priority order of routes to redirect to
    const defaultRoutes = [
        { path: "/dashboard", permission: Permission.DASHBOARD_VIEW },
        { path: "/insights", permission: Permission.INSIGHTS_VIEW },
        { path: "/nodes", permission: Permission.NODES_VIEW },
        { path: "/alarms", permission: Permission.ALARMS_VIEW },
        { path: "/reports", permission: Permission.REPORTS_VIEW },
        { path: "/users", permission: Permission.USERS_VIEW },
        { path: "/roles", permission: Permission.ROLES_VIEW },
        { path: "/settings", permission: Permission.SETTINGS_VIEW },
    ];
    // Find first route user has access to
    const defaultRoute = defaultRoutes.find((route) => PermissionChecker.hasPermission(route.permission));
    const from = ((_b = (_a = location.state) === null || _a === void 0 ? void 0 : _a.from) === null || _b === void 0 ? void 0 : _b.pathname) ||
        (defaultRoute === null || defaultRoute === void 0 ? void 0 : defaultRoute.path) ||
        "/unauthorized";
    return React.createElement(Navigate, { to: from, replace: true });
};
export default RootRedirect;
